(() => {
  const root = document.querySelector('[data-aza-oils]');
  if (!root) return;
  const form = root.querySelector('[data-aza-filters]');
  const grid = root.querySelector('[data-aza-grid]');
  const items = [...grid.querySelectorAll('[data-aza-item]')];
  const count = root.querySelector('[data-aza-count]');
  const empty = root.querySelector('[data-aza-empty]');
  const controls = {
    soort: form.querySelector('[data-aza-type]'),
    geur: form.querySelector('[data-aza-scent]'),
    moment: form.querySelector('[data-aza-moment]'),
    sortering: form.querySelector('[data-aza-sort]')
  };
  const collator = new Intl.Collator(document.documentElement.lang || 'nl', { sensitivity: 'base' });

  function readUrl() {
    const params = new URLSearchParams(location.search);
    for (const [key, control] of Object.entries(controls)) {
      const value = params.get(key);
      control.value = value && [...control.options].some(option => option.value === value)
        ? value : control.options[0].value;
    }
  }

  function render(writeUrl = false) {
    const kind = controls.soort.value;
    const scent = controls.geur.value;
    const moment = controls.moment.value;
    const sort = controls.sortering.value;
    let visible = 0;

    for (const item of items) {
      const matches = (kind === 'all' || item.dataset.type === kind)
        && (scent === 'all' || item.dataset.scent === scent)
        && (moment === 'all' || item.dataset.moments.split(',').includes(moment));
      item.hidden = !matches;
      if (matches) visible++;
    }

    const sorted = [...items].sort((a, b) => {
      if (sort === 'name-asc') return collator.compare(a.dataset.name, b.dataset.name);
      if (sort === 'name-desc') return collator.compare(b.dataset.name, a.dataset.name);
      if (sort === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price) || Number(a.dataset.rank) - Number(b.dataset.rank);
      if (sort === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price) || Number(a.dataset.rank) - Number(b.dataset.rank);
      return Number(a.dataset.rank) - Number(b.dataset.rank);
    });
    grid.replaceChildren(...sorted);
    count.textContent = `${visible} ${visible === 1 ? 'product' : 'producten'} gevonden`;
    empty.hidden = visible !== 0;

    if (writeUrl) {
      const url = new URL(location.href);
      for (const [key, control] of Object.entries(controls)) {
        if (control.selectedIndex === 0) url.searchParams.delete(key);
        else url.searchParams.set(key, control.value);
      }
      history.replaceState(null, '', url);
    }
  }

  form.addEventListener('change', () => render(true));
  root.querySelectorAll('[data-aza-quick-type]').forEach(button => {
    button.addEventListener('click', () => {
      controls.soort.value = button.dataset.azaQuickType;
      render(true);
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      controls.soort.focus({ preventScroll: true });
    });
  });
  form.addEventListener('reset', event => {
    event.preventDefault();
    for (const control of Object.values(controls)) control.selectedIndex = 0;
    render(true);
  });
  root.querySelector('[data-aza-clear]').addEventListener('click', () => {
    for (const control of Object.values(controls)) control.selectedIndex = 0;
    render(true);
    controls.soort.focus();
  });
  window.addEventListener('popstate', () => { readUrl(); render(); });
  readUrl();
  render();
})();
